// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"82f8e9e3","239":"59e5ce32","455":"ea316cb2","977":"3ef90a86"}[chunkId] + ".chunk.js";
};